import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { useLocationsOptions } from "./useLocationsOptions";
import { useActivityLocations } from "./useActivityLocations";
import { useTaskTypeFilterConfig } from "./useTaskTypeFilterConfig";
import { PICKUP_LOCATIONS_ID, TASK_TYPE_ID } from "../constants/filterIds";
import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";

export function usePickupLocationsFilter(
  filterValues: FilterValue[]
): MultiSelectFilter {
  const { t } = useTranslation();
  const enableAddonOrdersV2 = useFlag(FLAGS.ENABLE_ADDON_ORDERS_V2);
  const defaultValue = {
    filterId: PICKUP_LOCATIONS_ID,
    value: [],
  };

  const { hasConfig, config } = useTaskTypeFilterConfig(
    PICKUP_LOCATIONS_ID,
    filterValues
  );
  const taskTypeValue = filterValues.find(
    ({ filterId }) => filterId === TASK_TYPE_ID
  );
  const taskTypeValueValue = (taskTypeValue as StringFilterValue)?.value ?? "";

  let enabled: boolean;

  if (hasConfig) {
    // Config found - use it (takes precedence)
    enabled = config !== null;
  } else {
    // No config found - use existing logic unchanged
    // Support both v1 (pickAndRefill, refill) and v2 (addonOrder) task types
    enabled = enableAddonOrdersV2
      ? taskTypeValueValue === "addonOrder"
      : taskTypeValueValue === "refill" ||
        taskTypeValueValue === "pickAndRefill";
  }
  const { data: taskLocations, isFetching } = useActivityLocations(
    taskTypeValueValue,
    "pickup",
    enabled
  );
  const options = useLocationsOptions(taskTypeValueValue, taskLocations ?? []);

  return {
    inputType: InputType.MultiSelect,
    filterType: FilterType.Filter,
    id: PICKUP_LOCATIONS_ID,
    title: t("pickupLocation"),
    options,
    enabled,
    defaultValue,
    showSearch: true,
    noResultsTitle: t("noLocationsString"),
    noResultsDescription: t("noLocationsAvailableTaskTypeString"),
    isFetching,
  };
}
